var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 75C0 33.5786 33.5786 0 75 0C116.421 0 150 33.5786 150 75C150 116.421 116.421 150 75 150C33.5786 150 0 116.421 0 75Z",
    fill: "#E9ECF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2095 91.0005C37.2095 91.0005 46.6192 77.1923 54.8148 76.043C61.1893 74.8922 62.7066 76.3307 65.7418 78.0569C73.0265 81.7964 77.5795 81.5087 84.8652 77.7692C87.5968 76.3308 89.1147 75.1805 95.1856 76.043C103.381 77.1938 112.791 91.0005 112.791 91.0005C95.1856 120.054 54.8148 120.054 37.2095 91.0005ZM74.8471 37.2093C85.471 37.2093 94.273 45.2636 94.273 55.3322C94.273 65.4003 85.4705 73.7416 74.8471 73.7416C64.2231 73.7416 55.7236 65.3997 55.7236 55.3322C55.7236 45.2641 64.2227 37.2093 74.8471 37.2093Z",
    fill: "#9CA9B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.8c7d8f1982f1fc5c8bb48868e65bb6e8.svg";
export { ForwardRef as ReactComponent };